var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1927 14.2305C19.6769 15.238 20.7169 16.603 20.7169 18.423V21.673H25.0502V18.423C25.0502 16.0613 21.1827 14.6638 18.1927 14.2305Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3846 13.0075C18.7788 13.0075 20.718 11.0683 20.718 8.67415C20.718 6.27999 18.7788 4.34082 16.3846 4.34082C15.8755 4.34082 15.3988 4.44915 14.9438 4.60082C15.843 5.71665 16.3846 7.13582 16.3846 8.67415C16.3846 10.2125 15.843 11.6317 14.9438 12.7475C15.3988 12.8992 15.8755 13.0075 16.3846 13.0075Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88467 13.0075C12.2788 13.0075 14.218 11.0683 14.218 8.67415C14.218 6.27999 12.2788 4.34082 9.88467 4.34082C7.4905 4.34082 5.55133 6.27999 5.55133 8.67415C5.55133 11.0683 7.4905 13.0075 9.88467 13.0075ZM9.88467 6.50749C11.0763 6.50749 12.0513 7.48249 12.0513 8.67415C12.0513 9.86582 11.0763 10.8408 9.88467 10.8408C8.693 10.8408 7.718 9.86582 7.718 8.67415C7.718 7.48249 8.693 6.50749 9.88467 6.50749Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88469 14.0908C6.99219 14.0908 1.21802 15.5425 1.21802 18.4242V21.6742H18.5514V18.4242C18.5514 15.5425 12.7772 14.0908 9.88469 14.0908ZM16.3847 19.5075H3.38468V18.435C3.60135 17.655 6.95969 16.2575 9.88469 16.2575C12.8097 16.2575 16.168 17.655 16.3847 18.4242V19.5075Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.132812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.158d421348a92ef328879a396186c067.svg";
export { ForwardRef as ReactComponent };